var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_c('NavBar',{attrs:{"headtitle":'选择大区',"typeFn":2}}),_c('div',{staticClass:"serverBox"},[_c('div',{staticClass:"serverList"},[_c('ul',_vm._l((_vm.serverList),function(item){return _c('li',{key:item.serverid,on:{"click":function($event){return _vm.$router.push({
              path: '/wanttoSell/selectRole',
              query: {
                gameid: _vm.gameId,
                gameName: _vm.gameName,
                serverid: item.serverid,
                serverName: item.server_name,
              },
            })}}},[_vm._v("\n          "+_vm._s(item.server_name)+"\n        ")])}),0)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }